import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  main: {
    height: '100vh'
  },
  root: {
    marginTop: -22,
    marginRight: -96,
    marginLeft: -96
  },
  content: { marginBottom: 60 },
  top: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    paddingBottom: 64
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '12px 0'
  },
  appBar: {
    backgroundColor: `${theme.palette.background.default} !important`,
    marginTop: 0
  },
  startIcon: {
    marginRight: -4
  },
  btnText2: { fontWeight: 500, color: theme.palette.primary.contrastText },
  filtersContainer: { margin: '16px 0' },
  row: {
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 1fr',
    gap: 24,
    margin: '16px 0',
    alignItems: 'flex-end'
  },
  title: { fontWeight: 500, fontSize: 18, color: theme.palette.text.primary },
  subTitle: { fontWeight: 500, fontSize: 14 },
  sectionTitle: { marginTop: 24 },
  buttonContainer: {
    marginTop: 30,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '40vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  footer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    margin: '-23px -108px',
    padding: '24px 130px 24px 96px',
    background: theme.palette.background.default,
    borderTop: `2px solid ${theme.palette.grey[300]}`,
    position: 'fixed',
    width: '100%',
    bottom: 24,
    zIndex: 5,
    [theme.breakpoints.down('sm')]: {
      // margin: '-22px -16px 0px -16px',
      // overflow: 'visible',
      // alignSelf: 'unset'
    }
  },
  redText: { color: theme.palette.primary.main, fontWeight: 500, fontSize: 16 },
  whiteText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    fontSize: 16
  },
  cancelBtn: { margin: '0 8px' },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.background.default
  },
  circularProgressDelete: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))
export default useStyles
